import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../utils/mockData';
import { 
  Users, 
  GraduationCap, 
  MessageCircle, 
  Home, 
  Dumbbell, 
  Briefcase,
  Heart,
  Globe,
  Smartphone
} from 'lucide-react';

const iconMap = {
  1: Users,
  2: GraduationCap,
  3: MessageCircle,
  4: Home,
  5: Dumbbell,
  6: Briefcase,
  7: Heart,
  8: Globe,
  9: Smartphone
};

const ServicesSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section 
      id="services"
      ref={sectionRef}
      className={`py-20 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
      style={{ backgroundColor: '#f8f9fa' }}
    >
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6"
            style={{ color: '#587740' }}
          >
            Our Services
          </h2>
          <p 
            className="text-lg md:text-xl"
            style={{ color: '#5e5e5e' }}
          >
            We offer a wide range of services designed to empower you to live independently 
            and pursue your aspirations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {services.map((service, index) => {
            const Icon = iconMap[service.id];
            return (
              <Card 
                key={service.id}
                className={`hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-none ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ 
                  transitionDelay: `${index * 100}ms`,
                  backgroundColor: 'white'
                }}
              >
                <CardHeader>
                  <div 
                    className="w-14 h-14 rounded-lg flex items-center justify-center mb-4"
                    style={{ backgroundColor: '#AABC5A' }}
                  >
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle 
                    className="text-xl font-bold"
                    style={{ color: '#587740' }}
                  >
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription 
                    className="text-base leading-relaxed mb-4"
                    style={{ color: '#5e5e5e' }}
                  >
                    {service.description}
                  </CardDescription>
                  {service.points.length > 0 && (
                    <ul className="space-y-2">
                      {service.points.map((point, idx) => (
                        <li 
                          key={idx}
                          className="flex items-start text-sm"
                          style={{ color: '#5e5e5e' }}
                        >
                          <span 
                            className="inline-block w-1.5 h-1.5 rounded-full mt-2 mr-2 flex-shrink-0"
                            style={{ backgroundColor: '#81b956' }}
                          />
                          {point}
                        </li>
                      ))}
                    </ul>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
